import React, { useEffect, useState } from 'react';
import { X, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import axiosInstance from '../api/axiosInstance';
import './AnnouncementBanner.css';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [current, setCurrent] = useState(0);
  const [dismissed, setDismissed] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (announcements.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % announcements.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [announcements]);

  const fetchAnnouncements = async () => {
    try {
      const response = await axiosInstance.get('/announcements/website');
      if (response.data.success) {
        setAnnouncements(response.data.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = (id) => {
    setDismissed([...dismissed, id]);
  };

  const visibleAnnouncements = announcements.filter(
    (a) => !dismissed.includes(a.id)
  );

  if (loading || visibleAnnouncements.length === 0) return null;

  const announcement = visibleAnnouncements[current % visibleAnnouncements.length];

  const getTypeColor = (type) => {
    switch (type) {
      case 'SALE': return '#EF4444';
      case 'NEW_ARRIVAL': return '#10B981';
      case 'EVENT': return '#F59E0B';
      case 'PROMO': return '#1565C0';
      default: return '#1565C0';
    }
  };

  return (
    <div className="announcement-wrapper">
      {/* Top Bar Announcement */}
      <div
        className="announcement-bar"
        style={{ background: getTypeColor(announcement.type) }}
      >
        <div className="announcement-bar-content">
          <span className="announcement-type-badge">
            {announcement.type}
          </span>
          <p className="announcement-bar-text">{announcement.title}</p>
          {announcement.linkUrl && (
            <a
              href={announcement.linkUrl}
              className="announcement-bar-link"
            >
              {announcement.linkText || 'Learn More'}
              <ArrowRight size={12} />
            </a>
          )}
        </div>
        <button
          className="announcement-bar-close"
          onClick={() => handleDismiss(announcement.id)}
        >
          <X size={14} />
        </button>
      </div>

      {/* Full Banner Announcements (with image/video) */}
      {visibleAnnouncements.some((a) => a.imageUrl || a.videoUrl) && (
        <div className="announcement-banners">
          {visibleAnnouncements
            .filter((a) => a.imageUrl || a.videoUrl)
            .map((ann) => (
              <div key={ann.id} className="announcement-banner-card">
                {ann.videoUrl ? (
                  <video
                    src={ann.videoUrl}
                    autoPlay
                    muted
                    loop
                    className="announcement-media"
                  />
                ) : (
                  <img
                    src={ann.imageUrl}
                    alt={ann.title}
                    className="announcement-media"
                  />
                )}
                <div className="announcement-banner-overlay">
                  <div className="announcement-banner-content">
                    <span
                      className="announcement-banner-type"
                      style={{ background: getTypeColor(ann.type) }}
                    >
                      {ann.type}
                    </span>
                    <h2 className="announcement-banner-title">{ann.title}</h2>
                    {ann.description && (
                      <p className="announcement-banner-desc">
                        {ann.description}
                      </p>
                    )}
                    {ann.linkUrl && (
                      <a
                        href={ann.linkUrl}
                        className="announcement-banner-btn"
                      >
                        {ann.linkText || 'Shop Now'}
                        <ArrowRight size={16} />
                      </a>
                    )}
                  </div>
                  <button
                    className="announcement-banner-close"
                    onClick={() => handleDismiss(ann.id)}
                  >
                    <X size={18} />
                  </button>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default AnnouncementBanner;